// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"40be7b81","977":"4e0f7f58"}[chunkId] + ".chunk.js";
};